import CONFIG from '@/config'
import { feishuLogin } from '@/api/user'
import store from '@/store'
import { FEISHU_CLIENT_ID, clearFeishuAuthQuery, getFeishuAuthCode, isFeishuClient, redirectToFeishuAuthorize } from '@/utils/feishu'
import { getLoginRoute, getSafeRedirect } from '@/utils/routeRedirect'
import { createRouter, createWebHashHistory } from 'vue-router'
import mainRoutes from './routes'
const { routesWhiteList } = CONFIG
// 全局路由
const globalRoutes = [
  {
    path: '/login',
    name: 'login',
    hidden: true,
    component: () => import('@/views/login'),
    meta: { isAuth: true, title: '登录', keepAlive: false },
  },
  {
    path: '/404',
    name: '404',
    hidden: true,
    meta: { isAuth: true, title: '404未找到', keepAlive: false },
    component: () => import('@/views/404'),
  },
  {
    path: '/403',
    name: '403',
    hidden: true,
    meta: { isAuth: true, title: '403无权限', keepAlive: false },
    component: () => import('@/views/403'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    redirect: '/404',
    hidden: true,
  },
]
let routeFlag = false
const router = createRouter({
  history: createWebHashHistory(),
  routes: globalRoutes.concat(mainRoutes),
})

let feishuLoginPromise = null

function getAccessToken(response) {
  if (typeof response?.data === 'string') {
    return response.data
  }
  return response?.data?.access_token || response?.data?.accessToken || response?.data?.token || response?.access_token || response?.accessToken || response?.token
}

function isSuccessResponse(response) {
  return response?.code === undefined || response.code === '200' || response.code === 200
}

function normalizeAccessToken(accessToken) {
  return /^bearer\s+/i.test(accessToken) ? accessToken : 'bearer ' + accessToken
}

async function handleFeishuLogin(feishuCode) {
  if (!feishuLoginPromise) {
    feishuLoginPromise = feishuLogin({ code: feishuCode, appId: FEISHU_CLIENT_ID })
      .then(async response => {
        if (!isSuccessResponse(response)) {
          throw new Error(response?.message || '飞书登录失败')
        }
        const accessToken = getAccessToken(response)
        if (!accessToken) {
          throw new Error('飞书登录未返回 access_token')
        }
        await store.dispatch('user/setAccessToken', normalizeAccessToken(accessToken))
      })
  }

  try {
    return await feishuLoginPromise
  } finally {
    feishuLoginPromise = null
  }
}

async function handleUrlToken(to, next) {
  const urlToken = to.query.token
  if (!urlToken) return false

  await store.dispatch('user/setAccessToken', 'bearer ' + urlToken)
  if (to.query.redirect) {
    next(getSafeRedirect(to.query.redirect))
    return true
  }

  return false
}

async function handleFeishuAuth(to, next) {
  const feishuCode = getFeishuAuthCode(to.query)
  if (!feishuCode) return false

  try {
    await handleFeishuLogin(feishuCode)
    clearFeishuAuthQuery()
    routeFlag = false
    next(getSafeRedirect(to.query.redirect))
    return true
  } catch (error) {
    clearFeishuAuthQuery()
    return false
  }
}

async function ensureUserRoutes(to, next) {
  if (routeFlag) return true

  try {
    await store.dispatch('user/setMenu')
    await store.dispatch('user/getUserInfo')
    routeFlag = true
    return true
  } catch (error) {
    await store.dispatch('user/resetAll')
    next(getLoginRoute(to))
    return false
  }
}

function hasRoutePermission(to) {
  const accessRoutes = store.getters['user/flatMenuList']
  return accessRoutes.map(v => v.path).includes(to.path)
}

router.beforeEach(async (to, from, next) => {
  if (await handleUrlToken(to, next)) return

  const token = store.getters['user/accessToken']
  const feishuCode = getFeishuAuthCode(to.query)

  if (!token && feishuCode && (await handleFeishuAuth(to, next))) return

  if (!token && !feishuCode && isFeishuClient()) {
    redirectToFeishuAuthorize()
    next(false)
    return
  }

  if (routesWhiteList.includes(to.path)) {
    routeFlag = false
    next()
    return
  }

  if (!token) {
    routeFlag = false
    next(getLoginRoute(to))
    return
  }

  if (!(await ensureUserRoutes(to, next))) return

  if (to.query.redirect) {
    next(getSafeRedirect(to.query.redirect))
    return
  }

  if (to.path === null) {
    next('*')
    return
  }

  if (hasRoutePermission(to)) {
    next()
    return
  }

  next('/403')
})

export default router
